import BaseRequest from './BaseRequest';

const schema = 'orderbook';
/**
 * key base on host:port
 */
export default class OrderBookRequest extends BaseRequest {
  /**
	 * @param {Object} params
	 * @param {string} params.coin
	 * @param {string} params.currency
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchAllOrderBook(params) {
    const url = `${schema}/all`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.coin
	 * @param {string} params.currency
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchBuyOrderBook(params) {
    const url = `${schema}/buy`;
    return this.get(url, params);
  }

  /**
	 * @param {Object} params
	 * @param {string} params.coin
	 * @param {string} params.currency
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */
  fetchSellOrderBook(params) {
    const url = `${schema}/sell`;
    return this.get(url, params);
  }
}
